export default "__VITE_ASSET__9b0b8dd5__"